export default {
  ad_view_type: 'grid',
  isMobile: false,
};



// WEBPACK FOOTER //
// ./src/store/state.js